var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPermission(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 409.71,
    height: 325.152,
    viewBox: "0 0 409.71 325.152",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_627",
    "data-name": "Group 627",
    transform: "translate(-1455 -4688)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_622",
    "data-name": "Group 622",
    transform: "translate(1455 4688)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3850",
    "data-name": "Path 3850",
    d: "M681.732,223.952H301.816a1.511,1.511,0,1,1,0-3.022H681.732a1.511,1.511,0,1,1,0,3.022Z",
    transform: "translate(-300.305 -195.114)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_473",
    "data-name": "Ellipse 473",
    cx: 8.854,
    cy: 9.051,
    rx: 8.854,
    ry: 9.051,
    transform: "translate(18.518 0)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_474",
    "data-name": "Ellipse 474",
    cx: 8.854,
    cy: 9.051,
    rx: 8.854,
    ry: 9.051,
    transform: "translate(49.105 0)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_475",
    "data-name": "Ellipse 475",
    cx: 8.854,
    cy: 9.051,
    rx: 8.854,
    ry: 9.051,
    transform: "translate(79.692 0)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3851",
    "data-name": "Path 3851",
    d: "M729.808,192.742H708.081a1.645,1.645,0,1,0,0,3.291h21.727a1.645,1.645,0,1,0,0-3.291Z",
    transform: "translate(-366.797 -190.499)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3852",
    "data-name": "Path 3852",
    d: "M729.808,200.126H708.081a1.645,1.645,0,1,0,0,3.291h21.727a1.645,1.645,0,1,0,0-3.291Z",
    transform: "translate(-366.797 -191.708)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3853",
    "data-name": "Path 3853",
    d: "M729.808,207.5H708.081a1.645,1.645,0,1,0,0,3.291h21.727a1.645,1.645,0,1,0,0-3.291Z",
    transform: "translate(-366.797 -192.915)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_476",
    "data-name": "Ellipse 476",
    cx: 10.946,
    cy: 10.946,
    r: 10.946,
    transform: "translate(18.518 68.329)",
    fill: "#e6e7e8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3854",
    "data-name": "Path 3854",
    d: "M612.146,312.563H325.709a3.26,3.26,0,1,1,0-6.519H612.146a3.26,3.26,0,0,1,0,6.519Z",
    transform: "translate(-303.93 -209.048)",
    fill: "#e6e7e8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3855",
    "data-name": "Path 3855",
    d: "M537.023,327.965H325.709a3.26,3.26,0,0,1,0-6.52H537.023a3.26,3.26,0,1,1,0,6.52Z",
    transform: "translate(-303.93 -211.57)",
    fill: "#e6e7e8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_477",
    "data-name": "Ellipse 477",
    cx: 10.946,
    cy: 10.946,
    r: 10.946,
    transform: "translate(18.518 239.184)",
    fill: "#e6e7e8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3856",
    "data-name": "Path 3856",
    d: "M612.146,516.867H325.709a3.26,3.26,0,1,1,0-6.519H612.146a3.646,3.646,0,0,1,3.441,3.511,3.219,3.219,0,0,1-3.441,3.008Z",
    transform: "translate(-303.93 -242.497)",
    fill: "#e6e7e8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3857",
    "data-name": "Path 3857",
    d: "M537.023,532.269H325.709a3.26,3.26,0,0,1,0-6.52H537.023a3.26,3.26,0,1,1,0,6.52Z",
    transform: "translate(-303.93 -245.019)",
    fill: "#e6e7e8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_478",
    "data-name": "Ellipse 478",
    cx: 10.946,
    cy: 10.946,
    r: 10.946,
    transform: "translate(18.518 147.317)",
    fill: "#e6e7e8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3858",
    "data-name": "Path 3858",
    d: "M612.146,407.014H325.709a3.26,3.26,0,0,1,0-6.519H612.146a3.26,3.26,0,0,1,0,6.519Z",
    transform: "translate(-303.93 -224.512)",
    fill: "#e6e7e8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3859",
    "data-name": "Path 3859",
    d: "M572.257,422.416H325.709a3.26,3.26,0,0,1,0-6.52H572.257a3.26,3.26,0,1,1,0,6.52Z",
    transform: "translate(-303.93 -227.034)",
    fill: "#e6e7e8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3860",
    "data-name": "Path 3860",
    d: "M555.523,437.818H325.709a3.26,3.26,0,1,1,0-6.52H555.523a3.26,3.26,0,0,1,0,6.52Z",
    transform: "translate(-303.93 -229.555)",
    fill: "#e6e7e8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3861",
    "data-name": "Path 3861",
    d: "M620.911,555.184H578.14a15.992,15.992,0,0,1-15.974-15.973V519.6a15.992,15.992,0,0,1,15.974-15.974h42.771A15.992,15.992,0,0,1,636.885,519.6v19.61a15.992,15.992,0,0,1-15.974,15.973ZM578.14,505.3a14.318,14.318,0,0,0-14.3,14.3v19.61a14.317,14.317,0,0,0,14.3,14.3h42.771a14.317,14.317,0,0,0,14.3-14.3V519.6a14.318,14.318,0,0,0-14.3-14.3Z",
    transform: "translate(-343.177 -241.397)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3877",
    "data-name": "Path 3877",
    d: "M627.661,498.546H575.88V483.311c0-12.292,11.614-22.292,25.89-22.292s25.89,10,25.89,22.292Zm-50.108-1.673h48.436V483.311c0-11.37-10.864-20.62-24.218-20.62s-24.218,9.25-24.218,20.62Z",
    transform: "translate(-345.423 -234.421)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_625",
    "data-name": "Group 625",
    transform: "translate(1735.421 4883.862)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_489",
    "data-name": "Ellipse 489",
    cx: 64.645,
    cy: 64.645,
    r: 64.645,
    transform: "translate(0 0)",
    fill: "#3943b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3913",
    "data-name": "Path 3913",
    d: "M698.813,563.611V551.242a17.91,17.91,0,0,0-35.821,0v12.369a9.312,9.312,0,0,0-8.893,9.3v29.229h53.608V572.91A9.312,9.312,0,0,0,698.813,563.611ZM680.9,539.638a11.617,11.617,0,0,1,11.6,11.6V563.59H669.3V551.242A11.617,11.617,0,0,1,680.9,539.638Z",
    transform: "translate(-616.258 -503.09)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3914",
    "data-name": "Path 3914",
    d: "M686.962,580.3a4.819,4.819,0,1,0-7.529,3.982v10.474h5.421V584.28a4.812,4.812,0,0,0,2.109-3.982Z",
    transform: "translate(-617.499 -505.341)",
    fill: "#3943b7"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPermission);
export default __webpack_public_path__ + "static/media/permission.71dccbddf851f438f6a67f2519629609.svg";
export { ForwardRef as ReactComponent };